/* eslint-disable indent */
/* eslint-disable array-bracket-newline */
import { IDexTrade } from '@kattana-io/common';
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../helpers/formatters';
import TableCardMobile from '../../../molecules/Table/mobile/TableCard';
import { formatTimestamp, formatTx, toFixed4 } from '../formatters';
import Loader from '../../common/Loader';
import TickerCell from '../TickerCell';
import { IMyPositionsSelector } from '.';

interface IMyPositionsTableMobileProps extends IMyPositionsSelector {
  trades: IDexTrade[];
  tickers: any;
  loading: boolean;
  openTx: (tx: string) => void;
}

const getColorForItem = (row: any) => {
  if (row.buy === 1) {
    return 'green';
  }
  return 'red';
};

const MyPositionsTableMobile = ({
  tickers,
  loading,
  trades,
  base,
  base_decimals,
  quote,
  quote_decimals,
  flipped,
  openTx,
}: IMyPositionsTableMobileProps) => {
  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Date',
        accessor: 'timestamp',
        parser: (value) => formatTimestamp(value),
        width: 120,
      },
      item_2: {
        name: 'Price ($)',
        accessor: 'price_usd',
        parser: (_, row) =>
          `${toFixed4(flipped ? row.price_b_usd : row.price_a_usd)} $`,
      },
    },
    row_2: {
      item_1: {
        name: 'Amount',
        accessor: 'amountIn',
        parser: (_, row) => `${toFixed4(row.amount0 / 10 ** base_decimals)} 
        ${flipped ? quote : base}`,
        width: 120,
      },
      item_2: {
        name: 'Total',
        accessor: 'amountOut',
        parser: (_, row) => `${toFixed4(row.amount1 / 10 ** quote_decimals)} 
        ${flipped ? base : quote}`,
      },
    },
    row_3: {
      item_1: {
        name: 'Tx Value ($)',
        accessor: 'value_usd',
        parser: (value) => `${toFixed4(value)}`,
        width: 120,
      },
      item_2: {
        name: 'Tx Hash',
        accessor: 'tx',
        color: 'navy',
        parser: (value) => formatTx(value),
        onClick: (row) => openTx(row.tx),
      },
    },
    row_4: {
      item_1: {
        name: `Price ${quote}`,
        accessor: 'price',
        parser: (_, row) =>
          `${toFixed4(flipped ? row.price_b : row.price_a)} ${
            flipped ? base : quote
          }`,
        width: 120,
      },
      row_2: {
        name: 'Pair',
        accessor: 'ticker',
        parser: (_, row) => {
          const { chain, pair } = row;
          const key = `${chain}/${pair}`;
          const ticker = tickers[key];
          return <TickerCell path={key} ticker={ticker} />;
        },
      },
    },
  };

  const parsedData =
    !loading && trades.length
      ? formatMobileTableData({ data: trades, schema, getColorForItem })
      : undefined;

  return (
    <div className='dex_trades_mobile__table'>
      {loading ? (
        <div className='centrify'>
          <Loader />
        </div>
      ) : !trades.length ? (
        <div className='centrify'>No data found</div>
      ) : (
        parsedData?.map((row, index) => (
          <TableCardMobile key={index} data={row} />
        ))
      )}
    </div>
  );
};

export default MyPositionsTableMobile;
